module.exports = __webpack_public_path__ + "img/logo_agi.741c20f9.png";